import React from "react";
import {useMutation, useQuery} from "@apollo/client";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import NavBar from "../../components/common/NavBar";
import {confirmDelete} from "../../components/common/confirmDelete";
import MarketplaceListingDetails from "../../components/marketplace/MarketplaceListingDetails";
import useTranslation from "../../i18n/useTranslation";
import {CHANGE_MARKETPLACE_LISTING_STATUS, MARKETPLACE_LISTING, MY_MARKETPLACE_LISTINGS, RENEW_MARKETPLACE_LISTING} from "../../components/marketplace/queries";

export default function MarketplaceListingPage() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {id} = useParams();
    const [searchParams] = useSearchParams();
    const promoteOnLoad = searchParams.get("promote") === "1";
    const {data, loading, error} = useQuery(MARKETPLACE_LISTING, {variables: {id: Number(id)}});
    const [changeListingStatus] = useMutation(CHANGE_MARKETPLACE_LISTING_STATUS, {refetchQueries: [MARKETPLACE_LISTING, MY_MARKETPLACE_LISTINGS], awaitRefetchQueries: true});
    const [renewListing] = useMutation(RENEW_MARKETPLACE_LISTING, {refetchQueries: [MARKETPLACE_LISTING, MY_MARKETPLACE_LISTINGS], awaitRefetchQueries: true});
    const listing = data?.marketplaceListing;

    const updateListingStatus = async (status) => {
        if (!window.confirm(t("marketplaceManagementPage.actions.confirmStatus", {status: t(`marketplaceManagementPage.statuses.${status}`)}))) return;
        try {
            if (status === "available" && listing?.status === "expired") {
                await renewListing({variables: {id: Number(id), expiresAt: new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toISOString()}});
            } else {
                await changeListingStatus({variables: {id: Number(id), status, reason: `Status changed to ${status} by seller`}});
            }
            toast.success(t("marketplaceManagementPage.statusUpdated"));
        } catch (mutationError) {
            toast.error(mutationError.message);
        }
    };

    const removeListing = async () => {
        const confirmed = await confirmDelete({
            title: t("marketplaceManagementPage.actions.remove"),
            message: t("marketplaceManagementPage.actions.confirmRemove"),
            confirmLabel: t("marketplaceManagementPage.actions.remove"),
            cancelLabel: t("common.cancel"),
        });
        if (!confirmed) return;
        try {
            await changeListingStatus({variables: {id: Number(id), status: "removed", reason: "Removed by seller"}});
            toast.success(t("marketplaceManagementPage.statusUpdated"));
            navigate("/marketplace");
        } catch (mutationError) {
            toast.error(mutationError.message);
        }
    };

    return (
        <div className="content-wrapper">
            <NavBar navBarElem={{pageTitle: t("marketplacePage.title"), links: [{pageTitle: t("marketplacePage.title"), navLink: "/marketplace"}, {pageTitle: listing?.title || t("marketplacePage.details"), active: true}]}}/>
            <section className="content"><div className="container-fluid">
                {loading ? <div className="text-center p-5">{t("common.loading")}</div> : null}
                {error ? <div className="alert alert-danger">{error.message}</div> : null}
                <MarketplaceListingDetails listing={listing} managementView autoPromote={promoteOnLoad} onEdit={() => navigate(`/marketplace/${id}/edit`)} onRemove={removeListing} onStatusChange={updateListingStatus} onPromote={(campaign) => navigate(`/advertise/campaign/${encodeURIComponent(campaign.id)}/edit`)}/>
            </div></section>
        </div>
    );
}
